module.exports = __webpack_public_path__ + "static/media/hb.8e04cd85.gif";